import Longclick from 'ws-longclick/src/longclick.js';
import Sticky from 'sticky-js';
import wsMediaQuery from 'ws-media-query/src/index.js';
import {
  WS_TABLE_SELECTOR
} from '../constants/index';

const $ = jQuery;

function init() {
  let tableBlocks = document.querySelectorAll(WS_TABLE_SELECTOR);

  if (!tableBlocks) {
    return FALSE;
  }

  tableBlocks.forEach(tableBlock => {
    assignScrollButtons(tableBlock);
    detectIfScrollable(tableBlock);
  });

  $(document).ajaxComplete(() => {
    init();
  });
}

function assignScrollButtons(targ) {
  var scrollMe = targ.querySelector('.table-block__table');
  var prevButton = targ.querySelector('.table-scroll__prev');
  var nextButton = targ.querySelector('.table-scroll__next');

  new Longclick({
    target: prevButton,
    mouseDown: function () {
      scrollMe.scroll({
        left: scrollMe.scrollLeft -= 50,
      });
    }
  });

  new Longclick({
    target: nextButton,
    mouseDown: function () {
      scrollMe.scroll({
        left: scrollMe.scrollLeft += 100,
      });
    }
  });

  prevButton.addEventListener('click', function(){
    scrollMe.scroll({
      left: scrollMe.scrollLeft -= 100,
    });
  });

  nextButton.addEventListener('click', function(){
    scrollMe.scroll({
      left: scrollMe.scrollLeft += 100,
    });
  });
}

function detectIfScrollable(targ) {

  document.addEventListener('DOMContentLoaded', function () {xx(targ);});
  window.addEventListener('resize', function () {xx(targ);});

  function xx (xxtarg) {
    var tableWrapper = xxtarg.querySelector('.table-block__table');
    var table = xxtarg.querySelector('table');
    var scroller = xxtarg.querySelector('.table-scroll');

    if (tableWrapper.offsetWidth < table.offsetWidth) {
      if (scroller.classList.contains('hidden')) {
        scroller.classList.remove('hidden');
      }
    } else {
      if (!scroller.classList.contains('hidden')) {
        scroller.classList.add('hidden');
      }
    }
  }
}

try {
  init();
  new Sticky('.table-scroll');
} catch (err) {
  console.warn(err);
}
